import { createAction, props } from '@ngrx/store';
import { StepCashData, StepLotteryData, StepScratchData } from '../models/stop-wizard.model';
import { CashFlowEntry } from 'src/app/shared/interfaces/shift-management/shift-management-interface';

export const setStopLotteryData = createAction(
  '[Stop Wizard] Set Lottery Data',
  props<{ lotteryData: Partial<StepLotteryData> }>()
);

export const setStopScratchData = createAction(
  '[Stop Wizard] Set Scratch Data',
  props<{ scratchData: Partial<StepScratchData> }>()
);

export const setStopOcrData = createAction(
  '[Stop Wizard] Set OCR Data',
  props<{ ocrData: CashFlowEntry[] }>()
);

export const setStopCashData = createAction(
  '[Stop Wizard] Set Cash Data',
  props<{ cashData: Partial<StepCashData> }>()
);

export const resetStopWizard = createAction('[Stop Wizard] Reset');
